import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import { Viewer } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import useAuth from '../../hooks/useAuth';
import UserCard from '../../components/userCard';

function Statement() {
  const title = 'Statement';
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;
  const { getStatement } = useAuth();
  const { getSession } = useAuth();
  const navigate = useNavigate();
  const user = getSession();
  const doc = getStatement();
  const a = 'data:application/pdf;base64,';
  const base64 = a + doc;
  const pdfContentType = 'application/pdf';

  const base64toBlob = (data: string) => {
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = data.substr(`data:${pdfContentType};base64,`.length);

    const bytes = atob(base64WithoutPrefix);
    const l = bytes.length;
    const out = new Uint8Array(l);
    // while (l--) {
    //   out[l] = bytes.charCodeAt(l);
    // }
    for (let i = 0; i < l; i += 1) {
      out[i] = bytes.charCodeAt(i);
    }

    return new Blob([out], { type: pdfContentType });
  };
  const url = URL.createObjectURL(base64toBlob(base64));
  if (user) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/console">Dashboard</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className="page-title">{title}</h1>
          <div className="row">
            <div className="col-lg-3 rounded">
              <UserCard/>
            </div>
            <div className="col-lg-9">
              <div
                className="rpv-core__viewer"
                style={{
                  border: '1px solid rgba(232 238 241)',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <div
                  style={{
                    alignItems: 'center',
                    backgroundColor: '#eeeeee',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    padding: '4px',
                  }}
                >
                  <Toolbar />
                </div>
                <div
                  style={{
                    flex: 1,
                    overflow: 'hidden',
                  }}
                >
                  <Viewer fileUrl={ url } plugins={[toolbarPluginInstance]} />
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    );
  }
  navigate('/login');
}

export default Statement;
